export const LogoMark = ({ className = "w-8 h-8", light = false }) => {
  const line = light ? "#D8CCBB" : "#173E47";
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <path
        d="M4 19 L14 8 L24 19"
        fill="none"
        stroke={line}
        strokeWidth="1.6"
        strokeLinecap="square"
      />
      <path
        d="M10 25 L19 16 L28 25"
        fill="none"
        stroke={line}
        strokeWidth="1.6"
        strokeLinecap="square"
      />
      <rect x="13.4" y="15.6" width="5.2" height="5.2" fill="none" stroke={line} strokeWidth="1.4" />
      <line x1="16" y1="15.6" x2="16" y2="20.8" stroke={line} strokeWidth="1.4" />
      <line x1="13.4" y1="18.2" x2="18.6" y2="18.2" stroke={line} strokeWidth="1.4" />
    </svg>
  );
};

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3" data-testid="header-brand-logo">
    <img
      src="/assets/logo_circle.jpeg"
      alt="PLAN FIRST NSW logo"
      className="w-11 h-11 rounded-full object-cover shrink-0 border border-black/5"
    />
    <span className="leading-none">
      <span
        className={`block font-serif text-xl tracking-tight ${
          light ? "text-ivory" : "text-teal"
        }`}
      >
        PLAN FIRST
      </span>
      <span
        className={`block text-[10px] font-mono uppercase tracking-[0.42em] mt-1 ${
          light ? "text-sand" : "text-teal/60"
        }`}
      >
        NSW
      </span>
    </span>
  </span>
);
